import React, { createContext, useContext } from 'react';
import { SnackbarProvider, useSnackbar } from 'notistack';
import LogRocket from 'logrocket';

type variant = 'default'|'info'|'success'|'warning'

interface AlertProvider {
  useErrorAlert: (newMessage: string, error: Error) => void;
  useAlert: (newMessage: string,variant:variant) => void;
}
const AlertContext = createContext({} as AlertProvider);

export function useAlertContext() {
  return useContext(AlertContext);
}

interface Props {
  children: React.ReactNode;
}

export const AlertProvider: React.FC<Props> = ({children}) => {
  return (
    <SnackbarProvider maxSnack={3}>
      <AlertProviderChild>
        {children}
      </AlertProviderChild>
    </SnackbarProvider>
  );
    
};

export const AlertProviderChild: React.FC<Props> = ({ children }) => {
  const { enqueueSnackbar } = useSnackbar();


  //TODO: ERROR MESSAGES NEED TO BE SENT TO JEFFREY
  const useErrorAlert = (newMessage: string, error: Error) => {
    enqueueSnackbar(newMessage,{variant:'error'});
    console.log('new error Message',newMessage, error);

    LogRocket.captureMessage(newMessage, {
      extra: {
        // additional arbitrary data associated with the event
        error: error?.message??'No error message',
      },
    });
  };

  const useAlert = (newMessage: string,variant:variant) => {
    enqueueSnackbar(newMessage,{variant});
  };
  return (
    <AlertContext.Provider value={{ useErrorAlert,useAlert }}>
      {children}
    </AlertContext.Provider>
  );
};
